export interface PostNotFoundProps {
  message: string
}

export const usePostNotFound = (props: PostNotFoundProps) => {
  return {
    ...props,
  }
}
